import "../scss/base_rem.scss";
import "../scss/common_rem.scss";
import "../scss/charDetail_rem.scss";

import "./header";

import $ from "./jq";

 class CharsCtr{
    constructor(){
        this.$showNext = $(".j-show-next");
        this.$showPrev = $(".j-show-prev");
        this.$list = $(".chars-detail-list");
        
        this.totle = 27;
        this.id = $.getHrefParam("id");
        this.index = undefined != this.id && "" != this.id ?parseInt(this.id ) - 1: 0;
        this.showIndex();
    }

    setNextIndex(){
        this.index = (this.index + this.totle + 1 ) % this.totle;
    }

    setPrevIndex(){
        this.index = (this.index + this.totle -1 ) % this.totle;
    }

    showIndex(){
        let windowW = window.innerWidth;
        let translate = -windowW * this.index+ "px";
        this.$list.css({
            "transform" : `translateX(${translate})`
        })
    }

    init(){
        this.$showNext.on("click",()=>{
            this.setNextIndex();
            this.showIndex();
        })
        this.$showPrev.on("click",()=>{
            this.setPrevIndex();
            this.showIndex();
        })

    }
}
(function(){
    let charsCtr = new CharsCtr();
    charsCtr.init();
    $(".j-char-vdio-bg").on("click",function(){
        $(this).parent().addClass("hide");
        $(".j-char-vdio").get(0).contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*'); 
        $(".j-char-vdio").get(0).src = "";
    })

    $(".j-show-vdio").on("click",function(){
        let src =  $(this).data("src");
        $(".j-char-vdio").get(0).src = src;
        $(".j-dialog-wrapper").removeClass("hide");
    })
})()